import { getCookie } from '../utils/cookie';

import { request, apiURL } from '../utils/api';
export default class CamConfirmationService {
  getOptions(method: string, signal?: Object): Object {
    const options: Object = {
      method,
      headers: {
        Authorization: getCookie('session_id'),
        'Content-Type': 'application/json',
      },
    };
    if (signal) {
      options.signal = signal;
    }
    return options;
  }

  getAllByRecordId(
    organizationId: string,
    propertyId: string,
    camRecordsId: string,
    signal?: Object,
  ) {
    const options = this.getOptions('GET', signal);
    return request(
      `${apiURL}/${organizationId}/${propertyId}/cam-records/${camRecordsId}/confirmations`,
      options,
    );
  }
}
